import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Catalogue.css';

const Catalogue = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedProduct, setExpandedProduct] = useState(null);
  const location = useLocation();

  // Read URL parameters on component mount and when location changes
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get('category');
    if (categoryParam) {
      setSelectedCategory(categoryParam);
    }
  }, [location]);

  const catalogueData = [
    // AERIAL BUNDLED CABLES (ABC)
    {
      id: 1,
      category: "abc",
      mainCategory: "Aerial Bundled Cables",
      type: "ABC AL Cable 3C 50 + 54.6 SqMm",
      image: "/images/products/abc-3c-50.jpg",
      icon: "☁️",
      sizes: ["50mm² + 54.6mm²"],
      cores: "3 Core",
      voltage: "600/1000V",
      standard: "KS 2650",
      insulation: "UV Resistant XLPE",
      stock: "Available",
      application: "Overhead power distribution, rural electrification",
      features: ["Weather-resistant", "UV stabilized", "Safe and reliable"]
    },
    {
      id: 2,
      category: "abc",
      mainCategory: "Aerial Bundled Cables",
      type: "ABC Cable 2C 10 SqMm",
      image: "/images/products/abc-2c-10.jpg",
      icon: "☁️",
      sizes: ["10mm²"],
      cores: "2 Core",
      voltage: "600/1000V",
      standard: "KS 2650",
      insulation: "UV Resistant XLPE",
      stock: "Available",
      application: "Service connections from pole to building",
      features: ["Flexible", "Easy to terminate", "Weather resistant"]
    },
    {
      id: 3,
      category: "abc",
      mainCategory: "Aerial Bundled Cables",
      type: "ABC Cable 2C 16 SqMm",
      image: "/images/products/abc-2c-16.jpg",
      icon: "☁️",
      sizes: ["16mm²"],
      cores: "2 Core",
      voltage: "600/1000V",
      standard: "KS 2650",
      insulation: "UV Resistant XLPE",
      stock: "Available",
      application: "Overhead service drops",
      features: ["High strength", "Weather resistant", "Long service life"]
    },

    // ARMOURED ALUMINIUM CABLES
    {
      id: 4,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "1C 185 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-1c-185.jpg",
      icon: "🛡️⚪",
      sizes: ["185mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Industrial power supply, direct burial",
      features: ["Steel wire armour", "High current capacity", "Mechanical protection"]
    },
    {
      id: 5,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "1C 240 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-1c-240.jpg",
      icon: "🛡️⚪",
      sizes: ["240mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Main feeders, substations",
      features: ["Cost-effective", "Lightweight", "Good mechanical protection"]
    },
    {
      id: 6,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "1C 300 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-1c-300.jpg",
      icon: "🛡️⚪",
      sizes: ["300mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "High current industrial applications",
      features: ["High conductivity", "Robust construction", "Long service life"]
    },
    {
      id: 7,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "1C 400 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-1c-400.jpg",
      icon: "🛡️⚪",
      sizes: ["400mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Heavy industrial power distribution",
      features: ["Extra heavy duty", "High current rating", "Superior protection"]
    },
    {
      id: 8,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "1C 500 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-1c-500.jpg",
      icon: "🛡️⚪",
      sizes: ["500mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Main power distribution",
      features: ["Very high current capacity", "Heavy duty armour"]
    },
    {
      id: 9,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "1C 630 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-1c-630.jpg",
      icon: "🛡️⚪",
      sizes: ["630mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Extra high current industrial feeders",
      features: ["Maximum current capacity", "Heaviest duty construction"]
    },
    {
      id: 10,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "3.5C 25 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-35c-25.jpg",
      icon: "🛡️⚪⚪⚪",
      sizes: ["25mm²"],
      cores: "3.5 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "3-phase with reduced neutral",
      features: ["Reduced neutral", "Space saving", "Cost effective"]
    },
    {
      id: 11,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "3.5C 120 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-35c-120.jpg",
      icon: "🛡️⚪⚪⚪",
      sizes: ["120mm²"],
      cores: "3.5 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Industrial 3-phase with reduced neutral",
      features: ["Balanced design", "Armoured protection"]
    },
    {
      id: 12,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "3.5C 150 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-35c-150.jpg",
      icon: "🛡️⚪⚪⚪",
      sizes: ["150mm²"],
      cores: "3.5 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Industrial power with reduced neutral",
      features: ["High capacity", "Armoured protection"]
    },
    {
      id: 13,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "3.5C 240 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-35c-240.jpg",
      icon: "🛡️⚪⚪⚪",
      sizes: ["240mm²"],
      cores: "3.5 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "High power 3-phase with reduced neutral",
      features: ["High current", "Space efficient", "Robust protection"]
    },
    {
      id: 14,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "4C 6.0 SqMm SOLID Aluminium Armoured",
      image: "/images/products/arm-al-4c-6.jpg",
      icon: "🛡️⚪⚪⚪⚪",
      sizes: ["6.0mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC + SWA",
      stock: "Available",
      application: "Control and power circuits",
      features: ["Solid conductors", "Compact design", "Armoured protection"]
    },
    {
      id: 15,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "4C 10 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-4c-10.jpg",
      icon: "🛡️⚪⚪⚪⚪",
      sizes: ["10mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Industrial control and power",
      features: ["4 core for 3-phase + neutral", "Armoured protection"]
    },
    {
      id: 16,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "4C 16 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-4c-16.jpg",
      icon: "🛡️⚪⚪⚪⚪",
      sizes: ["16mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Industrial power distribution",
      features: ["4 core complete", "Armoured for direct burial"]
    },
    {
      id: 17,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "4C 25 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-4c-25.jpg",
      icon: "🛡️⚪⚪⚪⚪",
      sizes: ["25mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Industrial feeders",
      features: ["Balanced 4-core design", "Full armour protection"]
    },
    {
      id: 18,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "4C 35 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-4c-35.jpg",
      icon: "🛡️⚪⚪⚪⚪",
      sizes: ["35mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Industrial main feeders",
      features: ["Medium duty", "4-core balanced", "Heavy duty armour"]
    },
    {
      id: 19,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "4C 50 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-4c-50.jpg",
      icon: "🛡️⚪⚪⚪⚪",
      sizes: ["50mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Industrial power distribution",
      features: ["High current 4-core", "Full mechanical protection"]
    },
    {
      id: 20,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "4C 70 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-4c-70.jpg",
      icon: "🛡️⚪⚪⚪⚪",
      sizes: ["70mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Multiple batches (472m, 73m, 90m)",
      application: "Available",
      features: ["High capacity", "4-core balanced", "Robust armour"]
    },
    {
      id: 21,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "4C 95 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-4c-95.jpg",
      icon: "🛡️⚪⚪⚪⚪",
      sizes: ["95mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Industrial main power",
      features: ["Very high capacity", "Full 4-core", "Superior protection"]
    },
    {
      id: 22,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "4C 120 SqMm XLPE Aluminium Armoured",
      image: "/images/products/arm-al-4c-120.jpg",
      icon: "🛡️⚪⚪⚪⚪",
      sizes: ["120mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "XLPE + SWA",
      stock: "Available",
      application: "High power industrial distribution",
      features: ["XLPE insulation for higher temp", "High current", "Armoured"]
    },
    {
      id: 23,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "4C 150 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-4c-150.jpg",
      icon: "🛡️⚪⚪⚪⚪",
      sizes: ["150mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Main industrial feeders",
      features: ["Extra high capacity", "4-core complete", "Heavy armour"]
    },
    {
      id: 24,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "4C 185 SqMm Aluminium Armoured",
      image: "/images/products/arm-al-4c-185.jpg",
      icon: "🛡️⚪⚪⚪⚪",
      sizes: ["185mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Very high power distribution",
      features: ["Maximum capacity 4-core", "Industrial grade", "Full armour"]
    },
    {
      id: 25,
      category: "armoured-al",
      mainCategory: "Armoured Aluminium Cables",
      type: "4C 240 SqMm XLPE Aluminium Armoured",
      image: "/images/products/arm-al-4c-240.jpg",
      icon: "🛡️⚪⚪⚪⚪",
      sizes: ["240mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "XLPE + SWA",
      stock: "Available",
      application: "Extra high power industrial",
      features: ["XLPE insulation", "Ultra high capacity", "Maximum protection"]
    },

    // ARMOURED COPPER CABLES
    {
      id: 26,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "1C 70 SqMm Copper Armoured",
      image: "/images/products/arm-cu-1c-70.jpg",
      icon: "🛡️🔴",
      sizes: ["70mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "High conductivity industrial power",
      features: ["Copper conductor", "Maximum conductivity", "Armoured protection"]
    },
    {
      id: 27,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "1C 120 SqMm Copper Armoured",
      image: "/images/products/arm-cu-1c-120.jpg",
      icon: "🛡️🔴",
      sizes: ["120mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "High current industrial",
      features: ["Copper conductor", "High current capacity"]
    },
    {
      id: 28,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "1C 240 SqMm Copper Armoured",
      image: "/images/products/arm-cu-1c-240.jpg",
      icon: "🛡️🔴",
      sizes: ["240mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Very high current industrial",
      features: ["Copper conductor", "Maximum conductivity", "Heavy duty armour"]
    },
    {
      id: 29,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "1C 300 SqMm Copper Armoured",
      image: "/images/products/arm-cu-1c-300.jpg",
      icon: "🛡️🔴",
      sizes: ["300mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Extra high current industrial",
      features: ["Copper conductor", "Ultra high capacity", "Industrial grade armour"]
    },
    {
      id: 30,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "1C 400 SqMm Copper Armoured",
      image: "/images/products/arm-cu-1c-400.jpg",
      icon: "🛡️🔴",
      sizes: ["400mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Maximum current industrial",
      features: ["Copper conductor", "Highest conductivity", "Super heavy armour"]
    },
    {
      id: 31,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "1C 630 SqMm Copper Armoured",
      image: "/images/products/arm-cu-1c-630.jpg",
      icon: "🛡️🔴",
      sizes: ["630mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Ultra high current industrial",
      features: ["Copper conductor", "Maximum possible capacity", "Heaviest armour"]
    },
    {
      id: 32,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "2C 1.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-2c-1.5.jpg",
      icon: "🛡️🔴🔴",
      sizes: ["1.5mm²"],
      cores: "2 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Control circuits, small power",
      features: ["Copper conductors", "2-core for single phase", "Armoured protection"]
    },
    {
      id: 33,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "2C 2.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-2c-2.5.jpg",
      icon: "🛡️🔴🔴",
      sizes: ["2.5mm²"],
      cores: "2 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Control and instrumentation",
      features: ["Small size", "2-core", "Full armour protection"]
    },
    {
      id: 34,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "2C 4.0 SqMm Copper Armoured",
      image: "/images/products/arm-cu-2c-4.0.jpg",
      icon: "🛡️🔴🔴",
      sizes: ["4.0mm²"],
      cores: "2 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Control and small power",
      features: ["Medium-small conductors", "Armoured protection"]
    },
    {
      id: 35,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "2C 10 SqMm Copper Armoured",
      image: "/images/products/arm-cu-2c-10.jpg",
      icon: "🛡️🔴🔴",
      sizes: ["10mm²"],
      cores: "2 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Power and control",
      features: ["Medium conductors", "2-core", "Armoured"]
    },
    {
      id: 36,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "2C 16 SqMm Copper Armoured",
      image: "/images/products/arm-cu-2c-16.jpg",
      icon: "🛡️🔴🔴",
      sizes: ["16mm²"],
      cores: "2 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Power circuits",
      features: ["Larger conductors", "2-core power", "Armour protection"]
    },
    {
      id: 37,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "2C 25.0 SqMm Copper Armoured",
      image: "/images/products/arm-cu-2c-25.jpg",
      icon: "🛡️🔴🔴",
      sizes: ["25mm²"],
      cores: "2 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Heavy power circuits",
      features: ["Large conductors", "2-core heavy duty", "Full armour"]
    },
    {
      id: 38,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "2C 35 SqMm Copper Armoured",
      image: "/images/products/arm-cu-2c-35.jpg",
      icon: "🛡️🔴🔴",
      sizes: ["35mm²"],
      cores: "2 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "High power circuits",
      features: ["Large copper conductors", "High current", "Armour protected"]
    },
    {
      id: 39,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "3C 2.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-3c-2.5.jpg",
      icon: "🛡️🔴🔴🔴",
      sizes: ["2.5mm²"],
      cores: "3 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "3-phase control circuits",
      features: ["3-core for 3-phase", "Small size", "Armour protection"]
    },
    {
      id: 40,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "3C 4.0 SqMm Copper Armoured",
      image: "/images/products/arm-cu-3c-4.0.jpg",
      icon: "🛡️🔴🔴🔴",
      sizes: ["4.0mm²"],
      cores: "3 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "3-phase control and small power",
      features: ["3-core balanced", "Medium-small", "Armoured"]
    },
    {
      id: 41,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "3C 6.0 SqMm Copper Armoured",
      image: "/images/products/arm-cu-3c-6.0.jpg",
      icon: "🛡️🔴🔴🔴",
      sizes: ["6.0mm²"],
      cores: "3 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "3-phase power circuits",
      features: ["3-core", "Medium power", "Armour protected"]
    },
    {
      id: 42,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "3C 25.0 SqMm Copper Armoured",
      image: "/images/products/arm-cu-3c-25.jpg",
      icon: "🛡️🔴🔴🔴",
      sizes: ["25mm²"],
      cores: "3 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "3-phase power distribution",
      features: ["Large 3-core", "High power", "Full armour"]
    },
    {
      id: 43,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "3C 95 SqMm Copper Armoured",
      image: "/images/products/arm-cu-3c-95.jpg",
      icon: "🛡️🔴🔴🔴",
      sizes: ["95mm²"],
      cores: "3 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "High power 3-phase industrial",
      features: ["Large copper 3-core", "Very high current", "Maximum protection"]
    },
    {
      id: 44,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 1.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-1.5.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["1.5mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Control circuits with neutral",
      features: ["4-core", "Small size", "Armour protection"]
    },
    {
      id: 45,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 2.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-2.5.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["2.5mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Control and small power with neutral",
      features: ["4-core", "Small conductors", "Full armour"]
    },
    {
      id: 46,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 4.0 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-4.0.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["4.0mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Control and power with neutral",
      features: ["4-core", "Medium-small", "Armoured"]
    },
    {
      id: 47,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 6.0 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-6.0.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["6.0mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Power with neutral",
      features: ["4-core balanced", "Medium power", "Armour protection"]
    },
    {
      id: 48,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 10 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-10.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["10mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Power distribution with neutral",
      features: ["4-core", "Medium power", "Full armour"]
    },
    {
      id: 49,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 16 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-16.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["16mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Industrial power with neutral",
      features: ["4-core", "Good power capacity", "Armour protection"]
    },
    {
      id: 50,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 25 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-25.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["25mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Industrial power distribution",
      features: ["Large 4-core", "High current", "Full armour"]
    },
    {
      id: 51,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 35.0 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-35.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["35mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Heavy industrial power",
      features: ["Large 4-core", "Very high current", "Maximum protection"]
    },
    {
      id: 52,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 50 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-50.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["50mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Main industrial power",
      features: ["Extra large 4-core", "Ultra high current", "Heavy duty armour"]
    },
    {
      id: 53,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 70 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-70.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["70mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "High power industrial",
      features: ["Very large 4-core", "Maximum current", "Super heavy armour"]
    },
    {
      id: 54,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 95 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-95.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["95mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Ultra high power industrial",
      features: ["Jumbo 4-core", "Absolute max current", "Heaviest duty armour"]
    },
    {
      id: 55,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 120 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-120.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["120mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Maximum power industrial",
      features: ["Giant 4-core", "Ultimate current", "Industrial grade armour"]
    },
    {
      id: 56,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 150 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-150.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["150mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Extra high power industrial",
      features: ["Mega 4-core", "Maximum power", "Heaviest armour"]
    },
    {
      id: 57,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 185 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-185.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["185mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Super high power",
      features: ["Ultra large 4-core", "Premium copper", "Maximum protection"]
    },
    {
      id: 58,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "4C 240 SqMm Copper Armoured",
      image: "/images/products/arm-cu-4c-240.jpg",
      icon: "🛡️🔴🔴🔴🔴",
      sizes: ["240mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Maximum power industrial",
      features: ["Giant 4-core", "Ultimate current capacity", "Heaviest duty armour"]
    },
    {
      id: 59,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "5C 1.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-5c-1.5.jpg",
      icon: "🛡️🔴🔴🔴🔴🔴",
      sizes: ["1.5mm²"],
      cores: "5 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Multi-circuit control",
      features: ["5-core", "Small conductors", "Full armour"]
    },
    {
      id: 60,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "5C 2.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-5c-2.5.jpg",
      icon: "🛡️🔴🔴🔴🔴🔴",
      sizes: ["2.5mm²"],
      cores: "5 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Multi-circuit control",
      features: ["5-core", "Small conductors", "Armoured"]
    },
    {
      id: 61,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "5C 10 SqMm Copper Armoured",
      image: "/images/products/arm-cu-5c-10.jpg",
      icon: "🛡️🔴🔴🔴🔴🔴",
      sizes: ["10mm²"],
      cores: "5 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Multi-circuit power",
      features: ["5-core", "Medium conductors", "Full armour"]
    },
    {
      id: 62,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "5C 16 SqMm Copper Armoured",
      image: "/images/products/arm-cu-5c-16.jpg",
      icon: "🛡️🔴🔴🔴🔴🔴",
      sizes: ["16mm²"],
      cores: "5 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Multi-circuit power distribution",
      features: ["5-core", "Larger conductors", "Armour protected"]
    },
    {
      id: 63,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "6C 1.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-6c-1.5.jpg",
      icon: "🛡️🔴🔴🔴🔴🔴🔴",
      sizes: ["1.5mm²"],
      cores: "6 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Multi-circuit control systems",
      features: ["6-core", "Small conductors", "Full armour"]
    },
    {
      id: 64,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "7C 1.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-7c-1.5.jpg",
      icon: "🛡️🔴🔴🔴🔴🔴🔴🔴",
      sizes: ["1.5mm²"],
      cores: "7 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Complex control systems",
      features: ["7-core", "Multi-circuit", "Armoured"]
    },
    {
      id: 65,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "10C 1.0 SqMm Copper Armoured",
      image: "/images/products/arm-cu-10c-1.0.jpg",
      icon: "🛡️🔴×10",
      sizes: ["1.0mm²"],
      cores: "10 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Multi-circuit control panels",
      features: ["10-core", "Compact", "Full armour"]
    },
    {
      id: 66,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "10C 1.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-10c-1.5.jpg",
      icon: "🛡️🔴×10",
      sizes: ["1.5mm²"],
      cores: "10 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Multi-circuit control",
      features: ["10-core", "Medium-small", "Armour protected"]
    },
    {
      id: 67,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "10C 4.0 SqMm Copper Armoured",
      image: "/images/products/arm-cu-10c-4.0.jpg",
      icon: "🛡️🔴×10",
      sizes: ["4.0mm²"],
      cores: "10 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Multi-circuit power and control",
      features: ["10-core", "Larger conductors", "Full armour"]
    },
    {
      id: 68,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "11C 1.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-11c-1.5.jpg",
      icon: "🛡️🔴×11",
      sizes: ["1.5mm²"],
      cores: "11 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Complex control systems",
      features: ["11-core", "High density", "Armoured"]
    },
    {
      id: 69,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "12C 1.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-12c-1.5.jpg",
      icon: "🛡️🔴×12",
      sizes: ["1.5mm²"],
      cores: "12 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Multi-circuit automation",
      features: ["12-core", "Compact design", "Full armour"]
    },
    {
      id: 70,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "12C 2.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-12c-2.5.jpg",
      icon: "🛡️🔴×12",
      sizes: ["2.5mm²"],
      cores: "12 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Multi-circuit power and control",
      features: ["12-core", "Larger conductors", "Armour protected"]
    },
    {
      id: 71,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "14C 1.0 SqMm Copper Armoured",
      image: "/images/products/arm-cu-14c-1.0.jpg",
      icon: "🛡️🔴×14",
      sizes: ["1.0mm²"],
      cores: "14 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "High density control",
      features: ["14-core", "Ultra compact", "Full armour"]
    },
    {
      id: 72,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "14C 1.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-14c-1.5.jpg",
      icon: "🛡️🔴×14",
      sizes: ["1.5mm²"],
      cores: "14 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Multi-circuit control panels",
      features: ["14-core", "High density", "Armoured"]
    },
    {
      id: 73,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "14C 4.0 SqMm Copper Armoured",
      image: "/images/products/arm-cu-14c-4.0.jpg",
      icon: "🛡️🔴×14",
      sizes: ["4.0mm²"],
      cores: "14 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "High density power control",
      features: ["14-core", "Larger conductors", "Full armour"]
    },
    {
      id: 74,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "19C 2.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-19c-2.5.jpg",
      icon: "🛡️🔴×19",
      sizes: ["2.5mm²"],
      cores: "19 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Complex automation systems",
      features: ["19-core", "Very high density", "Full armour"]
    },
    {
      id: 75,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "24C 1.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-24c-1.5.jpg",
      icon: "🛡️🔴×24",
      sizes: ["1.5mm²"],
      cores: "24 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Industrial control systems",
      features: ["24-core", "Maximum density", "Heavy duty armour"]
    },
    {
      id: 76,
      category: "armoured-cu",
      mainCategory: "Armoured Copper Cables",
      type: "27C 1.5 SqMm Copper Armoured",
      image: "/images/products/arm-cu-27c-1.5.jpg",
      icon: "🛡️🔴×27",
      sizes: ["1.5mm²"],
      cores: "27 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA",
      stock: "Available",
      application: "Large control systems",
      features: ["27-core", "Ultra high density", "Full armour"]
    },

    // AUTOMOTIVE CABLES
    {
      id: 77,
      category: "automotive",
      mainCategory: "Automotive Cables",
      type: "0.35 mm² Automotive Cable",
      image: "/images/products/auto-0.35.jpg",
      icon: "🚗",
      sizes: ["0.35mm²"],
      colors: ["BK/RD", "BK/WH", "BR", "BR/WH", "Light GR", "Violet", "PINK", "RD", "WH", "YL", "YL/BL", "YL/GR"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "Automotive wiring harnesses",
      features: ["Color coded", "Flexible", "Thin wall insulation"]
    },
    {
      id: 78,
      category: "automotive",
      mainCategory: "Automotive Cables",
      type: "0.5 mm² Automotive Cable",
      image: "/images/products/auto-0.5.jpg",
      icon: "🚗",
      sizes: ["0.5mm²"],
      colors: ["BK", "GR", "BL/BK", "BL/YL", "YL", "YL/BK", "YL/BL", "YL/GR", "BR/BL", "BR/WH", "BR/YL", "RD/BK", "RD/YL", "WH", "WH/GR", "WH/RD"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "Automotive wiring",
      features: ["Multiple colors", "Flexible", "Temperature rated"]
    },
    {
      id: 79,
      category: "automotive",
      mainCategory: "Automotive Cables",
      type: "0.75 mm² Automotive Cable",
      image: "/images/products/auto-0.75.jpg",
      icon: "🚗",
      sizes: ["0.75mm²"],
      colors: ["BK", "BL/BK", "BL/RD", "BR/BL", "BR/WH", "GR", "RD", "RD/BK", "RD/YL", "WH", "WH/RD"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "Automotive power and control",
      features: ["Medium gauge", "Color coded", "Flexible"]
    },
    {
      id: 80,
      category: "automotive",
      mainCategory: "Automotive Cables",
      type: "1.0 mm² Automotive Cable",
      image: "/images/products/auto-1.0.jpg",
      icon: "🚗",
      sizes: ["1.0mm²"],
      colors: ["BK", "BK/WH", "BL", "BR", "GR", "RD", "WH", "WH/BK"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "Automotive power circuits",
      features: ["Larger gauge", "Color options", "Durable"]
    },
    {
      id: 81,
      category: "automotive",
      mainCategory: "Automotive Cables",
      type: "1.5 mm² Automotive Cable",
      image: "/images/products/auto-1.5.jpg",
      icon: "🚗",
      sizes: ["1.5mm²"],
      colors: ["BL"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "Automotive power",
      features: ["Heavy duty", "Single color", "High current"]
    },
    {
      id: 82,
      category: "automotive",
      mainCategory: "Automotive Cables",
      type: "2.5 mm² Automotive Cable",
      image: "/images/products/auto-2.5.jpg",
      icon: "🚗",
      sizes: ["2.5mm²"],
      colors: ["YL"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "High power automotive",
      features: ["Thick gauge", "High current", "Durable"]
    },
    {
      id: 83,
      category: "automotive",
      mainCategory: "Automotive Cables",
      type: "5.0 mm² Automotive Cable",
      image: "/images/products/auto-5.0.jpg",
      icon: "🚗",
      sizes: ["5.0mm²"],
      colors: ["RD"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "Battery cables, heavy duty",
      features: ["Very thick", "High current capacity", "Starter circuits"]
    },
    {
      id: 84,
      category: "automotive",
      mainCategory: "Automotive Cables",
      type: "16.0 mm² Automotive Cable",
      image: "/images/products/auto-16.0.jpg",
      icon: "🚗",
      sizes: ["16.0mm²"],
      colors: ["YG"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "Battery cables, heavy equipment",
      features: ["Extra heavy duty", "Maximum current", "Starter motors"]
    },
    {
      id: 85,
      category: "automotive",
      mainCategory: "Automotive Cables (100m coils)",
      type: "1.0 mm² Automotive Cable 100m coils",
      image: "/images/products/auto-1.0-100m.jpg",
      icon: "🚗",
      sizes: ["1.0mm² x100m"],
      colors: ["BK", "WHT", "BR", "BL", "RD"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "Bulk automotive wiring",
      features: ["100m coils", "Color coded", "Bulk purchase"]
    },
    {
      id: 86,
      category: "automotive",
      mainCategory: "Automotive Cables (100m coils)",
      type: "1.5 mm² Automotive Cable 100m coils",
      image: "/images/products/auto-1.5-100m.jpg",
      icon: "🚗",
      sizes: ["1.5mm² x100m"],
      colors: ["BL", "BK", "BR", "GR"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "Bulk automotive power",
      features: ["100m coils", "Multiple colors", "Bulk purchase"]
    },
    {
      id: 87,
      category: "automotive",
      mainCategory: "Automotive Cables (100m coils)",
      type: "2.5 mm² Automotive Cable 100m coils",
      image: "/images/products/auto-2.5-100m.jpg",
      icon: "🚗",
      sizes: ["2.5mm² x100m"],
      colors: ["Grey", "BK", "BR"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "Bulk heavy duty automotive",
      features: ["100m coils", "Large gauge", "Bulk"]
    },
    {
      id: 88,
      category: "automotive",
      mainCategory: "Automotive Cables (90m coils)",
      type: "4.0 mm² Automotive Cable 90m coils",
      image: "/images/products/auto-4.0-90m.jpg",
      icon: "🚗",
      sizes: ["4.0mm² x90m"],
      colors: ["YG"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "Heavy automotive wiring",
      features: ["90m coils", "Large gauge", "Special length"]
    },
    {
      id: 89,
      category: "automotive",
      mainCategory: "Automotive Cables (90m coils)",
      type: "10.0 mm² Automotive Cable 90m coils",
      image: "/images/products/auto-10.0-90m.jpg",
      icon: "🚗",
      sizes: ["10.0mm² x90m"],
      colors: ["BK"],
      voltage: "Low Voltage",
      standard: "KS 04-314",
      insulation: "PVC",
      stock: "Available",
      application: "Very heavy automotive",
      features: ["90m coils", "Extra large", "Special application"]
    },

    // CNC CABLES
    {
      id: 90,
      category: "cnc",
      mainCategory: "CNC Cables (Concentric Neutral)",
      type: "CNC Cable 1C 10 SqMm",
      image: "/images/products/cnc-1c-10.jpg",
      icon: "⚡",
      sizes: ["10mm²"],
      cores: "1 Core with concentric neutral",
      voltage: "600/1000V",
      standard: "KS 1637",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Secondary distribution, service lines",
      features: ["Concentric neutral design", "Single core with neutral", "Easy termination"]
    },
    {
      id: 91,
      category: "cnc",
      mainCategory: "CNC Cables (Concentric Neutral)",
      type: "CNC Cable 1C 16 SqMm",
      image: "/images/products/cnc-1c-16.jpg",
      icon: "⚡",
      sizes: ["16mm²"],
      cores: "1 Core with concentric neutral",
      voltage: "600/1000V",
      standard: "KS 1637",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Larger secondary distribution",
      features: ["Concentric neutral", "Larger conductor", "Direct burial"]
    },

    // DOMESTIC CABLES
    {
      id: 92,
      category: "domestic",
      mainCategory: "Domestic Cables",
      type: "Domestic 6.0 mm² SC Cu/PVC-YG",
      image: "/images/products/domestic-6.0-yg.jpg",
      icon: "🏠",
      sizes: ["6.0mm²"],
      colors: ["YG"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "House wiring, lighting circuits",
      features: ["Single core", "Color coded", "Flame retardant"]
    },
    {
      id: 93,
      category: "domestic",
      mainCategory: "Domestic Cables",
      type: "Domestic 10.0 mm² SC Cu/PVC-RD/BK",
      image: "/images/products/domestic-10.0-rd.jpg",
      icon: "🏠",
      sizes: ["10.0mm²"],
      colors: ["RD", "BK", "YG"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Power circuits, heavy appliances",
      features: ["Larger conductor", "Multiple colors", "High current"]
    },
    {
      id: 94,
      category: "domestic",
      mainCategory: "Domestic Cables",
      type: "Domestic 12.0 mm² SC Cu/PVC-YG",
      image: "/images/products/domestic-12.0-yg.jpg",
      icon: "🏠",
      sizes: ["12.0mm²"],
      colors: ["YG"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Heavy power circuits",
      features: ["Large conductor", "Single color", "High capacity"]
    },
    {
      id: 95,
      category: "domestic",
      mainCategory: "Domestic Cables",
      type: "Domestic 35.0 mm² SC Cu/PVC-RD/BK/YG",
      image: "/images/products/domestic-35.0.jpg",
      icon: "🏠",
      sizes: ["35.0mm²"],
      colors: ["RD", "BK", "YG"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Main supply cables, heavy industrial",
      features: ["Very large conductor", "Multiple colors", "Maximum current"]
    },
    {
      id: 96,
      category: "domestic",
      mainCategory: "Domestic Cables",
      type: "Domestic 4.0 mm² SC Cu/PVC-RD",
      image: "/images/products/domestic-4.0-rd.jpg",
      icon: "🏠",
      sizes: ["4.0mm²"],
      colors: ["RD"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "General house wiring",
      features: ["Medium conductor", "Standard size", "Versatile"]
    },
    {
      id: 97,
      category: "domestic",
      mainCategory: "Domestic Cables (100m coils)",
      type: "Domestic 1.0 mm² SC Cu/PVC 100m coils",
      image: "/images/products/domestic-1.0-100m.jpg",
      icon: "🏠",
      sizes: ["1.0mm² x100m"],
      colors: ["BK", "RD", "YG"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Bulk house wiring",
      features: ["100m coils", "Multiple colors", "Economical"]
    },
    {
      id: 98,
      category: "domestic",
      mainCategory: "Domestic Cables (100m coils)",
      type: "Domestic 1.5 mm² SC Cu/PVC 100m coils",
      image: "/images/products/domestic-1.5-100m.jpg",
      icon: "🏠",
      sizes: ["1.5mm² x100m"],
      colors: ["BK", "BL", "RD", "YG"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Bulk lighting circuits",
      features: ["100m coils", "Color options", "Standard gauge"]
    },
    {
      id: 99,
      category: "domestic",
      mainCategory: "Domestic Cables (100m coils)",
      type: "Domestic 2.5 mm² SC Cu/PVC 100m coils",
      image: "/images/products/domestic-2.5-100m.jpg",
      icon: "🏠",
      sizes: ["2.5mm² x100m"],
      colors: ["YL", "YG", "GR"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Bulk power circuits",
      features: ["100m coils", "Multiple colors", "Medium gauge"]
    },
    {
      id: 100,
      category: "domestic",
      mainCategory: "Domestic Cables (100m coils)",
      type: "Domestic 4.0 mm² SC Cu/PVC 100m coils",
      image: "/images/products/domestic-4.0-100m.jpg",
      icon: "🏠",
      sizes: ["4.0mm² x100m"],
      colors: ["YG"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Bulk heavy circuits",
      features: ["100m coils", "Larger gauge", "Power circuits"]
    },
    {
      id: 101,
      category: "domestic",
      mainCategory: "Domestic Cables (100m coils)",
      type: "Domestic 6.0 mm² SC Cu/PVC 100m coils",
      image: "/images/products/domestic-6.0-100m.jpg",
      icon: "🏠",
      sizes: ["6.0mm² x100m"],
      colors: ["BK", "BL", "RD", "YG", "YL"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Bulk heavy power",
      features: ["100m coils", "Large gauge", "High current"]
    },
    {
      id: 102,
      category: "domestic",
      mainCategory: "Domestic Cables (100m coils)",
      type: "Domestic 10.0 mm² SC Cu/PVC 100m coils",
      image: "/images/products/domestic-10.0-100m.jpg",
      icon: "🏠",
      sizes: ["10.0mm² x100m"],
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Bulk main supply",
      features: ["100m coils", "Very large", "Main circuits"]
    },
    {
      id: 103,
      category: "domestic",
      mainCategory: "Domestic Cables (100m coils)",
      type: "Domestic 16.0 mm² SC Cu/PVC 100m coils",
      image: "/images/products/domestic-16.0-100m.jpg",
      icon: "🏠",
      sizes: ["16.0mm² x100m"],
      colors: ["RD", "YG"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Bulk heavy industrial",
      features: ["100m coils", "Extra large", "Maximum current"]
    },
    {
      id: 104,
      category: "domestic",
      mainCategory: "Domestic Cables (90m coils)",
      type: "Domestic 1.0 mm² SC Cu/PVC 90m coils",
      image: "/images/products/domestic-1.0-90m.jpg",
      icon: "🏠",
      sizes: ["1.0mm² x90m"],
      colors: ["RD", "YG"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Special length house wiring",
      features: ["90m coils", "Standard gauge", "Special length"]
    },
    {
      id: 105,
      category: "domestic",
      mainCategory: "Domestic Cables (90m coils)",
      type: "Domestic 1.5 mm² SC Cu/PVC 90m coils",
      image: "/images/products/domestic-1.5-90m.jpg",
      icon: "🏠",
      sizes: ["1.5mm² x90m"],
      colors: ["BK", "BL", "RD", "YG"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Special length lighting",
      features: ["90m coils", "Multiple colors", "Special length"]
    },
    {
      id: 106,
      category: "domestic",
      mainCategory: "Domestic Cables (90m coils)",
      type: "Domestic 2.5 mm² SC Cu/PVC 90m coils",
      image: "/images/products/domestic-2.5-90m.jpg",
      icon: "🏠",
      sizes: ["2.5mm² x90m"],
      colors: ["RD", "BK", "GR", "YL", "YG", "BL", "BR"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Special length power circuits",
      features: ["90m coils", "All colors available", "Versatile"]
    },
    {
      id: 107,
      category: "domestic",
      mainCategory: "Domestic Cables (90m coils)",
      type: "Domestic 4.0 mm² SC Cu/PVC 90m coils",
      image: "/images/products/domestic-4.0-90m.jpg",
      icon: "🏠",
      sizes: ["4.0mm² x90m"],
      colors: ["BK", "RD", "YG"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Special length heavy circuits",
      features: ["90m coils", "Medium gauge", "Special length"]
    },
    {
      id: 108,
      category: "domestic",
      mainCategory: "Domestic Cables (90m coils)",
      type: "Domestic 6.0 mm² SC Cu/PVC 90m coils",
      image: "/images/products/domestic-6.0-90m.jpg",
      icon: "🏠",
      sizes: ["6.0mm² x90m"],
      colors: ["BK", "RD", "YG", "YL"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Special length heavy power",
      features: ["90m coils", "Large gauge", "Special application"]
    },
    {
      id: 109,
      category: "domestic",
      mainCategory: "Domestic Cables (90m coils)",
      type: "Domestic 10.0 mm² SC Cu/PVC 90m coils",
      image: "/images/products/domestic-10.0-90m.jpg",
      icon: "🏠",
      sizes: ["10.0mm² x90m"],
      colors: ["BK", "RD", "YG"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Special length main supply",
      features: ["90m coils", "Very large", "Special order"]
    },
    {
      id: 110,
      category: "domestic",
      mainCategory: "Domestic Cables (90m coils)",
      type: "Domestic 16.0 mm² SC Cu/PVC 90m coils",
      image: "/images/products/domestic-16.0-90m.jpg",
      icon: "🏠",
      sizes: ["16.0mm² x90m"],
      colors: ["BK", "RD"],
      voltage: "450/750V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Special length heavy industrial",
      features: ["90m coils", "Extra large", "Special application"]
    },

    // FLEXIBLE CABLES
    {
      id: 111,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 1C 2.5 SqMm RD",
      image: "/images/products/flex-1c-2.5.jpg",
      icon: "〰️",
      sizes: ["2.5mm²"],
      colors: ["RD"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Flexible connections",
      features: ["Stranded copper", "Flexible", "Single core"]
    },
    {
      id: 112,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 1C 35 SqMm",
      image: "/images/products/flex-1c-35.jpg",
      icon: "〰️",
      sizes: ["35mm²"],
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Heavy flexible connections",
      features: ["Large flexible conductor", "High current", "Industrial"]
    },
    {
      id: 113,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 1C 95 SqMm",
      image: "/images/products/flex-1c-95.jpg",
      icon: "〰️",
      sizes: ["95mm²"],
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Very heavy flexible connections",
      features: ["Very large flexible", "High current", "Industrial"]
    },
    {
      id: 114,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 1C 630 SqMm",
      image: "/images/products/flex-1c-630.jpg",
      icon: "〰️",
      sizes: ["630mm²"],
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Maximum flexible power",
      features: ["Jumbo flexible", "Extreme current", "Special application"]
    },
    {
      id: 115,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 2C 2.5 SqMm BK",
      image: "/images/products/flex-2c-2.5.jpg",
      icon: "〰️〰️",
      sizes: ["2.5mm²"],
      cores: "2 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Flexible control",
      features: ["2-core flexible", "Small size", "Control applications"]
    },
    {
      id: 116,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 2C 4.0 SqMm BK",
      image: "/images/products/flex-2c-4.0.jpg",
      icon: "〰️〰️",
      sizes: ["4.0mm²"],
      cores: "2 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Flexible power and control",
      features: ["2-core", "Medium size", "Flexible"]
    },
    {
      id: 117,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 2C 6.0 SqMm BK",
      image: "/images/products/flex-2c-6.0.jpg",
      icon: "〰️〰️",
      sizes: ["6.0mm²"],
      cores: "2 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Flexible power",
      features: ["2-core", "Larger size", "Power applications"]
    },
    {
      id: 118,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 2C 10.0 SqMm BK",
      image: "/images/products/flex-2c-10.0.jpg",
      icon: "〰️〰️",
      sizes: ["10.0mm²"],
      cores: "2 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Heavy flexible power",
      features: ["2-core", "Large conductors", "Industrial flexible"]
    },
    {
      id: 119,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 2C 25.0 SqMm BK",
      image: "/images/products/flex-2c-25.0.jpg",
      icon: "〰️〰️",
      sizes: ["25.0mm²"],
      cores: "2 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Very heavy flexible power",
      features: ["2-core", "Very large", "Maximum flexible power"]
    },
    {
      id: 120,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 3C 0.5 SqMm BK",
      image: "/images/products/flex-3c-0.5.jpg",
      icon: "〰️〰️〰️",
      sizes: ["0.5mm²"],
      cores: "3 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Small flexible control",
      features: ["3-core", "Smallest", "Control cables"]
    },
    {
      id: 121,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 3C 0.75 SqMm",
      image: "/images/products/flex-3c-0.75.jpg",
      icon: "〰️〰️〰️",
      sizes: ["0.75mm²"],
      cores: "3 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Small 3-phase flexible",
      features: ["3-core", "Small size", "Control"]
    },
    {
      id: 122,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 3C 1.5 SqMm BK/WH",
      image: "/images/products/flex-3c-1.5.jpg",
      icon: "〰️〰️〰️",
      sizes: ["1.5mm²"],
      cores: "3 Core",
      colors: ["BK", "WH"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "3-phase flexible control",
      features: ["3-core", "Medium-small", "Flexible"]
    },
    {
      id: 123,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 3C 2.5 SqMm BK",
      image: "/images/products/flex-3c-2.5.jpg",
      icon: "〰️〰️〰️",
      sizes: ["2.5mm²"],
      cores: "3 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "3-phase flexible power",
      features: ["3-core", "Medium", "Power applications"]
    },
    {
      id: 124,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 3C 10.0 SqMm",
      image: "/images/products/flex-3c-10.0.jpg",
      icon: "〰️〰️〰️",
      sizes: ["10.0mm²"],
      cores: "3 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Heavy 3-phase flexible",
      features: ["3-core", "Large", "Industrial flexible"]
    },
    {
      id: 125,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 3.5C 70 SqMm",
      image: "/images/products/flex-35c-70.jpg",
      icon: "〰️〰️〰️⚡",
      sizes: ["70mm²"],
      cores: "3.5 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "3-phase with reduced neutral",
      features: ["3.5-core", "Very large", "Special design"]
    },
    {
      id: 126,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 4C 1.0 SqMm",
      image: "/images/products/flex-4c-1.0.jpg",
      icon: "〰️〰️〰️〰️",
      sizes: ["1.0mm²"],
      cores: "4 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "4-core flexible control",
      features: ["4-core", "Small", "Control with neutral"]
    },
    {
      id: 127,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 4C 1.5 SqMm",
      image: "/images/products/flex-4c-1.5.jpg",
      icon: "〰️〰️〰️〰️",
      sizes: ["1.5mm²"],
      cores: "4 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "4-core control",
      features: ["4-core", "Small", "General purpose"]
    },
    {
      id: 128,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 4C 2.5 SqMm",
      image: "/images/products/flex-4c-2.5.jpg",
      icon: "〰️〰️〰️〰️",
      sizes: ["2.5mm²"],
      cores: "4 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "4-core power and control",
      features: ["4-core", "Medium", "Versatile"]
    },
    {
      id: 129,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 4C 10 SqMm",
      image: "/images/products/flex-4c-10.jpg",
      icon: "〰️〰️〰️〰️",
      sizes: ["10mm²"],
      cores: "4 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "4-core flexible power",
      features: ["4-core", "Large", "Power applications"]
    },
    {
      id: 130,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 4C 35 SqMm",
      image: "/images/products/flex-4c-35.jpg",
      icon: "〰️〰️〰️〰️",
      sizes: ["35mm²"],
      cores: "4 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Heavy 4-core flexible",
      features: ["4-core", "Very large", "Industrial"]
    },
    {
      id: 131,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 4C 50 SqMm",
      image: "/images/products/flex-4c-50.jpg",
      icon: "〰️〰️〰️〰️",
      sizes: ["50mm²"],
      cores: "4 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Extra heavy 4-core flexible",
      features: ["4-core", "Jumbo", "Maximum power"]
    },
    {
      id: 132,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 5C 10 SqMm",
      image: "/images/products/flex-5c-10.jpg",
      icon: "〰️〰️〰️〰️〰️",
      sizes: ["10mm²"],
      cores: "5 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "5-core flexible control",
      features: ["5-core", "Large", "Multi-circuit"]
    },
    {
      id: 133,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 5C 35 SqMm",
      image: "/images/products/flex-5c-35.jpg",
      icon: "〰️〰️〰️〰️〰️",
      sizes: ["35mm²"],
      cores: "5 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "5-core heavy flexible",
      features: ["5-core", "Very large", "Industrial control"]
    },
    {
      id: 134,
      category: "flexible",
      mainCategory: "Flexible Cables",
      type: "Flex Cable 40C 1.0 SqMm",
      image: "/images/products/flex-40c-1.0.jpg",
      icon: "〰️×40",
      sizes: ["1.0mm²"],
      cores: "40 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Multi-circuit control",
      features: ["40-core", "High density", "Complex control"]
    },
    {
      id: 135,
      category: "flexible",
      mainCategory: "Flexible Cables (100m coils)",
      type: "Flex Cable 2C 2.5 SqMm 100m coil",
      image: "/images/products/flex-2c-2.5-100m.jpg",
      icon: "〰️〰️",
      sizes: ["2.5mm² x100m"],
      cores: "2 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Bulk flexible cable",
      features: ["100m coil", "2-core", "Bulk purchase"]
    },
    {
      id: 136,
      category: "flexible",
      mainCategory: "Flexible Cables (100m coils)",
      type: "Flex Cable 3C 0.75 SqMm 100m coil",
      image: "/images/products/flex-3c-0.75-100m.jpg",
      icon: "〰️〰️〰️",
      sizes: ["0.75mm² x100m"],
      cores: "3 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Bulk small control",
      features: ["100m coil", "3-core", "Small gauge"]
    },
    {
      id: 137,
      category: "flexible",
      mainCategory: "Flexible Cables (100m coils)",
      type: "Flex Cable 4C 1.0 SqMm 100m coil",
      image: "/images/products/flex-4c-1.0-100m.jpg",
      icon: "〰️〰️〰️〰️",
      sizes: ["1.0mm² x100m"],
      cores: "4 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Bulk 4-core control",
      features: ["100m coil", "4-core", "Small gauge"]
    },
    {
      id: 138,
      category: "flexible",
      mainCategory: "Flexible Cables (100m coils)",
      type: "Flex Cable 4C 1.5 SqMm 100m coil",
      image: "/images/products/flex-4c-1.5-100m.jpg",
      icon: "〰️〰️〰️〰️",
      sizes: ["1.5mm² x100m"],
      cores: "4 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Bulk 4-core control",
      features: ["100m coil", "4-core", "Small-medium"]
    },
    {
      id: 139,
      category: "flexible",
      mainCategory: "Flexible Cables (100m coils)",
      type: "Flex Cable 4C 6.0 SqMm 100m coil",
      image: "/images/products/flex-4c-6.0-100m.jpg",
      icon: "〰️〰️〰️〰️",
      sizes: ["6.0mm² x100m"],
      cores: "4 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Bulk 4-core power",
      features: ["100m coil", "4-core", "Larger gauge"]
    },
    {
      id: 140,
      category: "flexible",
      mainCategory: "Flexible Cables (50m coils)",
      type: "Flex Cable 2C 2.5 SqMm 50m coil",
      image: "/images/products/flex-2c-2.5-50m.jpg",
      icon: "〰️〰️",
      sizes: ["2.5mm² x50m"],
      cores: "2 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Half-coil flexible",
      features: ["50m coil", "2-core", "Small projects"]
    },
    {
      id: 141,
      category: "flexible",
      mainCategory: "Flexible Cables (50m coils)",
      type: "Flex Cable 3C 2.5 SqMm 50m coil",
      image: "/images/products/flex-3c-2.5-50m.jpg",
      icon: "〰️〰️〰️",
      sizes: ["2.5mm² x50m"],
      cores: "3 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Half-coil 3-phase",
      features: ["50m coil", "3-core", "Medium projects"]
    },
    {
      id: 142,
      category: "flexible",
      mainCategory: "Flexible Cables (90m coils)",
      type: "Flex Cable 2C 0.5 SqMm 90m coil",
      image: "/images/products/flex-2c-0.5-90m.jpg",
      icon: "〰️〰️",
      sizes: ["0.5mm² x90m"],
      cores: "2 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Special length small control",
      features: ["90m coil", "2-core", "Smallest gauge"]
    },
    {
      id: 143,
      category: "flexible",
      mainCategory: "Flexible Cables (90m coils)",
      type: "Flex Cable 2C 0.75 SqMm 90m coil",
      image: "/images/products/flex-2c-0.75-90m.jpg",
      icon: "〰️〰️",
      sizes: ["0.75mm² x90m"],
      cores: "2 Core",
      colors: ["BK", "WH"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Special length control",
      features: ["90m coil", "2-core", "Two colors"]
    },
    {
      id: 144,
      category: "flexible",
      mainCategory: "Flexible Cables (90m coils)",
      type: "Flex Cable 3C 0.5 SqMm 90m coil",
      image: "/images/products/flex-3c-0.5-90m.jpg",
      icon: "〰️〰️〰️",
      sizes: ["0.5mm² x90m"],
      cores: "3 Core",
      colors: ["BK", "WH"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Special length 3-phase control",
      features: ["90m coil", "3-core", "Smallest"]
    },
    {
      id: 145,
      category: "flexible",
      mainCategory: "Flexible Cables (90m coils)",
      type: "Flex Cable 3C 0.75 SqMm 90m coil",
      image: "/images/products/flex-3c-0.75-90m.jpg",
      icon: "〰️〰️〰️",
      sizes: ["0.75mm² x90m"],
      cores: "3 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Special length control",
      features: ["90m coil", "3-core", "Small"]
    },
    {
      id: 146,
      category: "flexible",
      mainCategory: "Flexible Cables (90m coils)",
      type: "Flex Cable 3C 1.0 SqMm 90m coil",
      image: "/images/products/flex-3c-1.0-90m.jpg",
      icon: "〰️〰️〰️",
      sizes: ["1.0mm² x90m"],
      cores: "3 Core",
      colors: ["BK", "WH"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Special length 3-phase",
      features: ["90m coil", "3-core", "Medium-small"]
    },
    {
      id: 147,
      category: "flexible",
      mainCategory: "Flexible Cables (90m coils)",
      type: "Flex Cable 3C 1.5 SqMm 90m coil",
      image: "/images/products/flex-3c-1.5-90m.jpg",
      icon: "〰️〰️〰️",
      sizes: ["1.5mm² x90m"],
      cores: "3 Core",
      colors: ["BK", "WH"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Special length power",
      features: ["90m coil", "3-core", "Medium"]
    },
    {
      id: 148,
      category: "flexible",
      mainCategory: "Flexible Cables (90m coils)",
      type: "Flex Cable 3C 2.5 SqMm 90m coil",
      image: "/images/products/flex-3c-2.5-90m.jpg",
      icon: "〰️〰️〰️",
      sizes: ["2.5mm² x90m"],
      cores: "3 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Special length power",
      features: ["90m coil", "3-core", "Larger"]
    },
    {
      id: 149,
      category: "flexible",
      mainCategory: "Flexible Cables (90m coils)",
      type: "Flex Cable 4C 1.0 SqMm 90m coil",
      image: "/images/products/flex-4c-1.0-90m.jpg",
      icon: "〰️〰️〰️〰️",
      sizes: ["1.0mm² x90m"],
      cores: "4 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Special length 4-core",
      features: ["90m coil", "4-core", "Small"]
    },
    {
      id: 150,
      category: "flexible",
      mainCategory: "Flexible Cables (90m coils)",
      type: "Flex Cable 4C 1.5 SqMm 90m coil",
      image: "/images/products/flex-4c-1.5-90m.jpg",
      icon: "〰️〰️〰️〰️",
      sizes: ["1.5mm² x90m"],
      cores: "4 Core",
      colors: ["BK"],
      voltage: "450/750V",
      standard: "KS EAS 117",
      insulation: "Flexible PVC",
      stock: "Available",
      application: "Special length 4-core",
      features: ["90m coil", "4-core", "Small-medium"]
    },

    // NON-ARMOURED ALUMINIUM CABLES
    {
      id: 151,
      category: "nonarm-al",
      mainCategory: "Non-Armoured Aluminium Cables",
      type: "1C 150 SqMm Aluminium",
      image: "/images/products/nonarm-al-1c-150.jpg",
      icon: "⚪",
      sizes: ["150mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "General wiring",
      features: ["Unarmoured", "Lightweight", "Economical"]
    },
    {
      id: 152,
      category: "nonarm-al",
      mainCategory: "Non-Armoured Aluminium Cables",
      type: "1C 185 SqMm Aluminium",
      image: "/images/products/nonarm-al-1c-185.jpg",
      icon: "⚪",
      sizes: ["185mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Power distribution",
      features: ["Large conductor", "Unarmoured", "PVC insulated"]
    },
    {
      id: 153,
      category: "nonarm-al",
      mainCategory: "Non-Armoured Aluminium Cables",
      type: "1C 240 SqMm Aluminium",
      image: "/images/products/nonarm-al-1c-240.jpg",
      icon: "⚪",
      sizes: ["240mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Main power distribution",
      features: ["Very large", "Unarmoured", "High current"]
    },
    {
      id: 154,
      category: "nonarm-al",
      mainCategory: "Non-Armoured Aluminium Cables",
      type: "1C 300 SqMm Aluminium",
      image: "/images/products/nonarm-al-1c-300.jpg",
      icon: "⚪",
      sizes: ["300mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Extra high power",
      features: ["Jumbo conductor", "Unarmoured", "Maximum current"]
    },
    {
      id: 155,
      category: "nonarm-al",
      mainCategory: "Non-Armoured Aluminium Cables",
      type: "1C 630 SqMm Aluminium",
      image: "/images/products/nonarm-al-1c-630.jpg",
      icon: "⚪",
      sizes: ["630mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Ultra high power",
      features: ["Giant conductor", "Unarmoured", "Maximum capacity"]
    },
    {
      id: 156,
      category: "nonarm-al",
      mainCategory: "Non-Armoured Aluminium Cables",
      type: "4C 25 SqMm Aluminium",
      image: "/images/products/nonarm-al-4c-25.jpg",
      icon: "⚪⚪⚪⚪",
      sizes: ["25mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "4-core distribution",
      features: ["4-core", "Unarmoured", "Balanced power"]
    },

    // NON-ARMOURED COPPER CABLES
    {
      id: 157,
      category: "nonarm-cu",
      mainCategory: "Non-Armoured Copper Cables",
      type: "1C 150 SqMm Copper",
      image: "/images/products/nonarm-cu-1c-150.jpg",
      icon: "🔴",
      sizes: ["150mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "High conductivity wiring",
      features: ["Copper conductor", "Unarmoured", "Maximum conductivity"]
    },
    {
      id: 158,
      category: "nonarm-cu",
      mainCategory: "Non-Armoured Copper Cables",
      type: "1C 185 SqMm Copper",
      image: "/images/products/nonarm-cu-1c-185.jpg",
      icon: "🔴",
      sizes: ["185mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "High power copper",
      features: ["Large copper", "Unarmoured", "High current"]
    },
    {
      id: 159,
      category: "nonarm-cu",
      mainCategory: "Non-Armoured Copper Cables",
      type: "1C 240 SqMm Copper",
      image: "/images/products/nonarm-cu-1c-240.jpg",
      icon: "🔴",
      sizes: ["240mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Very high power copper",
      features: ["Very large copper", "Unarmoured", "Premium conductivity"]
    },
    {
      id: 160,
      category: "nonarm-cu",
      mainCategory: "Non-Armoured Copper Cables",
      type: "1C 300 SqMm Copper",
      image: "/images/products/nonarm-cu-1c-300.jpg",
      icon: "🔴",
      sizes: ["300mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Extra high power copper",
      features: ["Jumbo copper", "Unarmoured", "Ultra high current"]
    },
    {
      id: 161,
      category: "nonarm-cu",
      mainCategory: "Non-Armoured Copper Cables",
      type: "1C 630 SqMm Copper",
      image: "/images/products/nonarm-cu-1c-630.jpg",
      icon: "🔴",
      sizes: ["630mm²"],
      cores: "1 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Maximum power copper",
      features: ["Giant copper", "Unarmoured", "Ultimate conductivity"]
    },
    {
      id: 162,
      category: "nonarm-cu",
      mainCategory: "Non-Armoured Copper Cables",
      type: "3.5C 25.0 SqMm Copper",
      image: "/images/products/nonarm-cu-35c-25.jpg",
      icon: "🔴🔴🔴⚡",
      sizes: ["25mm²"],
      cores: "3.5 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "3-phase with reduced neutral",
      features: ["Copper", "3.5-core", "Space saving"]
    },
    {
      id: 163,
      category: "nonarm-cu",
      mainCategory: "Non-Armoured Copper Cables",
      type: "3C 2.5 SqMm Copper",
      image: "/images/products/nonarm-cu-3c-2.5.jpg",
      icon: "🔴🔴🔴",
      sizes: ["2.5mm²"],
      cores: "3 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "3-phase control",
      features: ["Small 3-core", "Copper", "Unarmoured"]
    },

    // SOLAR CABLES
    {
      id: 164,
      category: "solar",
      mainCategory: "Solar Cables",
      type: "Solar Cable 6.0 SqMm x100 RD",
      image: "/images/products/solar-6.0.jpg",
      icon: "☀️",
      sizes: ["6.0mm² x100m"],
      colors: ["RD"],
      voltage: "600/1000V",
      standard: "TUV Certified",
      insulation: "XLPE",
      stock: "Available",
      application: "Solar panel connections",
      features: ["UV resistant", "Weather proof", "Solar certified"]
    },
    {
      id: 165,
      category: "solar",
      mainCategory: "Solar Cables",
      type: "Solar Cable 10.0 SqMm x100 BK",
      image: "/images/products/solar-10.0.jpg",
      icon: "☀️",
      sizes: ["10.0mm² x100m"],
      colors: ["BK"],
      voltage: "600/1000V",
      standard: "TUV Certified",
      insulation: "XLPE",
      stock: "Available",
      application: "Main solar array connections",
      features: ["UV resistant", "Weather proof", "Larger gauge"]
    },

    // SUBMERSIBLE CABLES
    {
      id: 166,
      category: "submersible",
      mainCategory: "Submersible Cables - Flat",
      type: "Submersible Cable Flat 3C 16 SqMm",
      image: "/images/products/sub-flat-3c-16.jpg",
      icon: "💧",
      sizes: ["16mm²"],
      cores: "3 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "3-phase submersible pumps",
      features: ["Flat design", "Water resistant", "3-core"]
    },
    {
      id: 167,
      category: "submersible",
      mainCategory: "Submersible Cables - Flat",
      type: "Submersible Cable Flat 4C 1.5 SqMm",
      image: "/images/products/sub-flat-4c-1.5.jpg",
      icon: "💧💧💧💧",
      sizes: ["1.5mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Small submersible pumps",
      features: ["Flat", "4-core", "Small size"]
    },
    {
      id: 168,
      category: "submersible",
      mainCategory: "Submersible Cables - Flat",
      type: "Submersible Cable Flat 4C 2.5 SqMm",
      image: "/images/products/sub-flat-4c-2.5.jpg",
      icon: "💧💧💧💧",
      sizes: ["2.5mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Medium submersible pumps",
      features: ["Flat", "4-core", "Medium size"]
    },
    {
      id: 169,
      category: "submersible",
      mainCategory: "Submersible Cables - Flat",
      type: "Submersible Cable Flat 4C 4.0 SqMm",
      image: "/images/products/sub-flat-4c-4.0.jpg",
      icon: "💧💧💧💧",
      sizes: ["4.0mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Standard submersible pumps",
      features: ["Flat", "4-core", "Standard size"]
    },
    {
      id: 170,
      category: "submersible",
      mainCategory: "Submersible Cables - Flat",
      type: "Submersible Cable Flat 4C 6 SqMm",
      image: "/images/products/sub-flat-4c-6.0.jpg",
      icon: "💧💧💧💧",
      sizes: ["6.0mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Larger submersible pumps",
      features: ["Flat", "4-core", "Larger size"]
    },
    {
      id: 171,
      category: "submersible",
      mainCategory: "Submersible Cables - Flat",
      type: "Submersible Cable Flat 4C 10 SqMm",
      image: "/images/products/sub-flat-4c-10.jpg",
      icon: "💧💧💧💧",
      sizes: ["10mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Heavy submersible pumps",
      features: ["Flat", "4-core", "Heavy duty"]
    },
    {
      id: 172,
      category: "submersible",
      mainCategory: "Submersible Cables - Flat",
      type: "Submersible Cable Flat 4C 16 SqMm",
      image: "/images/products/sub-flat-4c-16.jpg",
      icon: "💧💧💧💧",
      sizes: ["16mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Extra heavy submersible pumps",
      features: ["Flat", "4-core", "Extra heavy"]
    },
    {
      id: 173,
      category: "submersible",
      mainCategory: "Submersible Cables - Round",
      type: "Submersible Cable Round 2C 2.5 SqMm",
      image: "/images/products/sub-round-2c-2.5.jpg",
      icon: "💧",
      sizes: ["2.5mm²"],
      cores: "2 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Single phase submersible",
      features: ["Round", "2-core", "Single phase"]
    },
    {
      id: 174,
      category: "submersible",
      mainCategory: "Submersible Cables - Round",
      type: "Submersible Cable Round 2C 25.0 SqMm",
      image: "/images/products/sub-round-2c-25.jpg",
      icon: "💧",
      sizes: ["25.0mm²"],
      cores: "2 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "Large single phase pumps",
      features: ["Round", "2-core", "Large size"]
    },
    {
      id: 175,
      category: "submersible",
      mainCategory: "Submersible Cables - Round",
      type: "Submersible Cable Round 4C 2.5 SqMm",
      image: "/images/products/sub-round-4c-2.5.jpg",
      icon: "💧💧💧💧",
      sizes: ["2.5mm²"],
      cores: "4 Core",
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE",
      stock: "Available",
      application: "3-phase submersible with neutral",
      features: ["Round", "4-core", "3-phase + neutral"]
    },

    // TWIN CABLES
    {
      id: 176,
      category: "twin",
      mainCategory: "Twin Flat Cables (TF)",
      type: "TF Cables CU 1.0 SqMm",
      image: "/images/products/tf-1.0.jpg",
      icon: "⚡⚡",
      sizes: ["1.0mm²"],
      cores: "2 Core",
      voltage: "300/500V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Lighting and small appliances",
      features: ["Twin flat", "Small size", "PVC insulated"]
    },
    {
      id: 177,
      category: "twin",
      mainCategory: "Twin Flat Cables (TF)",
      type: "TF Cables CU 1.5 SqMm",
      image: "/images/products/tf-1.5.jpg",
      icon: "⚡⚡",
      sizes: ["1.5mm²"],
      cores: "2 Core",
      voltage: "300/500V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "General wiring",
      features: ["Twin flat", "Standard size"]
    },
    {
      id: 178,
      category: "twin",
      mainCategory: "Twin Flat Cables (TF)",
      type: "TF Cables CU 2.5 SqMm",
      image: "/images/products/tf-2.5.jpg",
      icon: "⚡⚡",
      sizes: ["2.5mm²"],
      cores: "2 Core",
      voltage: "300/500V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Power circuits",
      features: ["Twin flat", "Larger size"]
    },
    {
      id: 179,
      category: "twin",
      mainCategory: "Twin with Earth Cables (TWE)",
      type: "TWE Cables CU 1.0 SqMm",
      image: "/images/products/twe-1.0.jpg",
      icon: "⚡⚡🟢",
      sizes: ["1.0mm²"],
      cores: "3 Core (with earth)",
      voltage: "300/500V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Lighting with earth",
      features: ["Twin with earth", "Safety earth", "Small size"]
    },
    {
      id: 180,
      category: "twin",
      mainCategory: "Twin with Earth Cables (TWE)",
      type: "TWE Cables CU 1.5 SqMm",
      image: "/images/products/twe-1.5.jpg",
      icon: "⚡⚡🟢",
      sizes: ["1.5mm²"],
      cores: "3 Core (with earth)",
      voltage: "300/500V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "General wiring with earth",
      features: ["Twin with earth", "Standard size"]
    },
    {
      id: 181,
      category: "twin",
      mainCategory: "Twin with Earth Cables (TWE)",
      type: "TWE Cables CU 2.5 SqMm",
      image: "/images/products/twe-2.5.jpg",
      icon: "⚡⚡🟢",
      sizes: ["2.5mm²"],
      cores: "3 Core (with earth)",
      voltage: "300/500V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Power circuits with earth",
      features: ["Twin with earth", "Power rating"]
    },
    {
      id: 182,
      category: "twin",
      mainCategory: "Twin with Earth Cables (TWE)",
      type: "TWE Cables CU 4.0 SqMm",
      image: "/images/products/twe-4.0.jpg",
      icon: "⚡⚡🟢",
      sizes: ["4.0mm²"],
      cores: "3 Core (with earth)",
      voltage: "300/500V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Heavy circuits with earth",
      features: ["Twin with earth", "Large conductors"]
    },
    {
      id: 183,
      category: "twin",
      mainCategory: "Twin with Earth Cables (TWE)",
      type: "TWE Cables CU 6.0 SqMm",
      image: "/images/products/twe-6.0.jpg",
      icon: "⚡⚡🟢",
      sizes: ["6.0mm²"],
      cores: "3 Core (with earth)",
      voltage: "300/500V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "High power with earth",
      features: ["Twin with earth", "Large conductors"]
    },
    {
      id: 184,
      category: "twin",
      mainCategory: "Twin with Earth Cables (TWE)",
      type: "TWE Cables CU 10.0 SqMm",
      image: "/images/products/twe-10.0.jpg",
      icon: "⚡⚡🟢",
      sizes: ["10.0mm²"],
      cores: "3 Core (with earth)",
      voltage: "300/500V",
      standard: "KS EAS 114",
      insulation: "PVC",
      stock: "Available",
      application: "Maximum power with earth",
      features: ["Twin with earth", "Maximum size"]
    },

    // WELDING CABLES
    {
      id: 185,
      category: "welding",
      mainCategory: "Welding Cables",
      type: "Welding Cable SC 16 SqMm (black)",
      image: "/images/products/welding-16.jpg",
      icon: "⚡",
      sizes: ["16mm²"],
      colors: ["BK"],
      voltage: "600/1000V",
      standard: "BS 638",
      insulation: "EPR/PCP",
      stock: "Available",
      application: "Welding leads, electrode holders",
      features: ["Extra flexible", "Oil resistant", "Abrasion resistant"]
    },
    {
      id: 186,
      category: "welding",
      mainCategory: "Welding Cables",
      type: "Welding Cable SC 35 SqMm",
      image: "/images/products/welding-35.jpg",
      icon: "⚡",
      sizes: ["35mm²"],
      colors: ["BK"],
      voltage: "600/1000V",
      standard: "BS 638",
      insulation: "EPR/PCP",
      stock: "Available",
      application: "Heavy duty welding",
      features: ["Larger conductor", "High current", "Flexible"]
    },
    {
      id: 187,
      category: "welding",
      mainCategory: "Welding Cables",
      type: "Welding Cable SC 50 SqMm",
      image: "/images/products/welding-50.jpg",
      icon: "⚡",
      sizes: ["50mm²"],
      colors: ["BK"],
      voltage: "600/1000V",
      standard: "BS 638",
      insulation: "EPR/PCP",
      stock: "Available",
      application: "Very heavy duty welding",
      features: ["Very large", "Maximum current", "Industrial"]
    },

    // WINDING WIRES
    {
      id: 188,
      category: "winding",
      mainCategory: "Winding Wires - Fine",
      type: "Winding Wire 0.193 mm (36 SWG)",
      image: "/images/products/winding-36swg.jpg",
      icon: "🌀",
      sizes: ["0.193mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Fine motor windings, small coils",
      features: ["Fine gauge", "Enamelled", "High conductivity"]
    },
    {
      id: 189,
      category: "winding",
      mainCategory: "Winding Wires - Fine",
      type: "Winding Wire 0.21 mm (35 SWG)",
      image: "/images/products/winding-35swg.jpg",
      icon: "🌀",
      sizes: ["0.21mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Small motors, transformers",
      features: ["Fine", "Enamelled", "Precision"]
    },
    {
      id: 190,
      category: "winding",
      mainCategory: "Winding Wires - Medium-Fine",
      type: "Winding Wire 0.25 mm (33 SWG)",
      image: "/images/products/winding-33swg.jpg",
      icon: "🌀",
      sizes: ["0.25mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "General motor windings",
      features: ["Medium-fine", "Enamelled", "Versatile"]
    },
    {
      id: 191,
      category: "winding",
      mainCategory: "Winding Wires - Medium-Fine",
      type: "Winding Wire 0.28 mm (32 SWG)",
      image: "/images/products/winding-32swg.jpg",
      icon: "🌀",
      sizes: ["0.28mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Motor windings, coils",
      features: ["Medium", "Enamelled", "Good insulation"]
    },
    {
      id: 192,
      category: "winding",
      mainCategory: "Winding Wires - Medium",
      type: "Winding Wire 0.295 mm (31 SWG)",
      image: "/images/products/winding-31swg.jpg",
      icon: "🌀",
      sizes: ["0.295mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Transformers, motors",
      features: ["Medium", "Enamelled", "Popular size"]
    },
    {
      id: 193,
      category: "winding",
      mainCategory: "Winding Wires - Medium",
      type: "Winding Wire 0.30 mm (31 SWG)",
      image: "/images/products/winding-30swg.jpg",
      icon: "🌀",
      sizes: ["0.30mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Transformers, motors",
      features: ["Medium", "Enamelled", "Common size"]
    },
    {
      id: 194,
      category: "winding",
      mainCategory: "Winding Wires - Medium",
      type: "Winding Wire 0.315 mm (30 SWG)",
      image: "/images/products/winding-30swg-2.jpg",
      icon: "🌀",
      sizes: ["0.315mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Transformers",
      features: ["Medium", "Enamelled"]
    },
    {
      id: 195,
      category: "winding",
      mainCategory: "Winding Wires - Medium",
      type: "Winding Wire 0.345 mm (29 SWG)",
      image: "/images/products/winding-29swg.jpg",
      icon: "🌀",
      sizes: ["0.345mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Larger motors, transformers",
      features: ["Medium-large", "Enamelled", "Higher current"]
    },
    {
      id: 196,
      category: "winding",
      mainCategory: "Winding Wires - Medium-Large",
      type: "Winding Wire 0.40 mm (27 SWG)",
      image: "/images/products/winding-27swg.jpg",
      icon: "🌀",
      sizes: ["0.40mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Power transformers, large motors",
      features: ["Larger gauge", "Enamelled", "High current"]
    },
    {
      id: 197,
      category: "winding",
      mainCategory: "Winding Wires - Medium-Large",
      type: "Winding Wire 0.45 mm (26 SWG)",
      image: "/images/products/winding-26swg.jpg",
      icon: "🌀",
      sizes: ["0.45mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Heavy motors, transformers",
      features: ["Large", "Enamelled", "Power applications"]
    },
    {
      id: 198,
      category: "winding",
      mainCategory: "Winding Wires - Large",
      type: "Winding Wire 0.50 mm (25 SWG)",
      image: "/images/products/winding-25swg.jpg",
      icon: "🌀",
      sizes: ["0.50mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Large motors, heavy transformers",
      features: ["Large", "Enamelled", "High capacity"]
    },
    {
      id: 199,
      category: "winding",
      mainCategory: "Winding Wires - Large",
      type: "Winding Wire 0.53 mm (24.5 SWG)",
      image: "/images/products/winding-24.5swg.jpg",
      icon: "🌀",
      sizes: ["0.53mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Industrial motors",
      features: ["Large", "Enamelled", "Industrial"]
    },
    {
      id: 200,
      category: "winding",
      mainCategory: "Winding Wires - Large",
      type: "Winding Wire 0.56 mm (24 SWG)",
      image: "/images/products/winding-24swg.jpg",
      icon: "🌀",
      sizes: ["0.56mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Heavy industrial motors",
      features: ["Large", "Enamelled", "Heavy duty"]
    },
    {
      id: 201,
      category: "winding",
      mainCategory: "Winding Wires - Large",
      type: "Winding Wire 0.60 mm (24 SWG)",
      image: "/images/products/winding-24swg-2.jpg",
      icon: "🌀",
      sizes: ["0.60mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Large industrial motors",
      features: ["Extra large", "Enamelled", "Maximum current"]
    },
    {
      id: 202,
      category: "winding",
      mainCategory: "Winding Wires - Large",
      type: "Winding Wire 0.61 mm (23 SWG)",
      image: "/images/products/winding-23swg.jpg",
      icon: "🌀",
      sizes: ["0.61mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Very large motors",
      features: ["Very large", "Enamelled", "High power"]
    },
    {
      id: 203,
      category: "winding",
      mainCategory: "Winding Wires - Large",
      type: "Winding Wire 0.63 mm (23 SWG)",
      image: "/images/products/winding-23swg-2.jpg",
      icon: "🌀",
      sizes: ["0.63mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Very large motors, generators",
      features: ["Very large", "Enamelled", "Industrial"]
    },
    {
      id: 204,
      category: "winding",
      mainCategory: "Winding Wires - Large",
      type: "Winding Wire 0.67 mm (22.5 SWG)",
      image: "/images/products/winding-22.5swg.jpg",
      icon: "🌀",
      sizes: ["0.67mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Large industrial equipment",
      features: ["Extra large", "Enamelled", "Premium"]
    },
    {
      id: 205,
      category: "winding",
      mainCategory: "Winding Wires - Large",
      type: "Winding Wire 0.75 mm (21.5 SWG)",
      image: "/images/products/winding-21.5swg.jpg",
      icon: "🌀",
      sizes: ["0.75mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Heavy industrial",
      features: ["Very large", "Enamelled", "Heavy duty"]
    },
    {
      id: 206,
      category: "winding",
      mainCategory: "Winding Wires - Large",
      type: "Winding Wire 0.80 mm (21 SWG)",
      image: "/images/products/winding-21swg.jpg",
      icon: "🌀",
      sizes: ["0.80mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Large industrial",
      features: ["Large", "Enamelled", "Power"]
    },
    {
      id: 207,
      category: "winding",
      mainCategory: "Winding Wires - Large",
      type: "Winding Wire 0.85 mm (20.5 SWG)",
      image: "/images/products/winding-20.5swg.jpg",
      icon: "🌀",
      sizes: ["0.85mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Very heavy industrial",
      features: ["Extra large", "Enamelled", "Maximum"]
    },
    {
      id: 208,
      category: "winding",
      mainCategory: "Winding Wires - Large",
      type: "Winding Wire 0.95 mm (19.5 SWG)",
      image: "/images/products/winding-19.5swg.jpg",
      icon: "🌀",
      sizes: ["0.95mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Jumbo motors",
      features: ["Jumbo", "Enamelled", "Ultra power"]
    },
    {
      id: 209,
      category: "winding",
      mainCategory: "Winding Wires - Jumbo",
      type: "Winding Wire 1.12 mm (18.5 SWG)",
      image: "/images/products/winding-18.5swg.jpg",
      icon: "🌀",
      sizes: ["1.12mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Large transformers, generators",
      features: ["Jumbo", "Enamelled", "Very high current"]
    },
    {
      id: 210,
      category: "winding",
      mainCategory: "Winding Wires - Jumbo",
      type: "Winding Wire 1.18 mm (18.25 SWG)",
      image: "/images/products/winding-18.25swg.jpg",
      icon: "🌀",
      sizes: ["1.18mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Very large transformers",
      features: ["Jumbo", "Enamelled", "Maximum current"]
    },
    {
      id: 211,
      category: "winding",
      mainCategory: "Winding Wires - Jumbo",
      type: "Winding Wire 1.25 mm (18 SWG)",
      image: "/images/products/winding-18swg.jpg",
      icon: "🌀",
      sizes: ["1.25mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Power transformers",
      features: ["Jumbo", "Enamelled", "Industrial"]
    },
    {
      id: 212,
      category: "winding",
      mainCategory: "Winding Wires - Jumbo",
      type: "Winding Wire 1.40 mm (17 SWG)",
      image: "/images/products/winding-17swg.jpg",
      icon: "🌀",
      sizes: ["1.40mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Heavy transformers",
      features: ["Jumbo", "Enamelled", "Heavy"]
    },
    {
      id: 213,
      category: "winding",
      mainCategory: "Winding Wires - Jumbo",
      type: "Winding Wire 1.50 mm (16.5 SWG)",
      image: "/images/products/winding-16.5swg.jpg",
      icon: "🌀",
      sizes: ["1.50mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Very heavy transformers",
      features: ["Jumbo", "Enamelled", "High power"]
    },
    {
      id: 214,
      category: "winding",
      mainCategory: "Winding Wires - Jumbo",
      type: "Winding Wire 1.60 mm (16 SWG)",
      image: "/images/products/winding-16swg.jpg",
      icon: "🌀",
      sizes: ["1.60mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Maximum size windings",
      features: ["Jumbo", "Enamelled", "Maximum"]
    },
    {
      id: 215,
      category: "winding",
      mainCategory: "Winding Wires - Jumbo",
      type: "Winding Wire 1.80 mm (15 SWG)",
      image: "/images/products/winding-15swg.jpg",
      icon: "🌀",
      sizes: ["1.80mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Extra jumbo windings",
      features: ["Jumbo", "Enamelled", "Extra large"]
    },
    {
      id: 216,
      category: "winding",
      mainCategory: "Winding Wires - Jumbo",
      type: "Winding Wire 2.0 mm (14 SWG)",
      image: "/images/products/winding-14swg.jpg",
      icon: "🌀",
      sizes: ["2.0mm"],
      standard: "IEC 60317",
      insulation: "Enamel",
      stock: "Available",
      application: "Maximum size, large transformers",
      features: ["Maximum", "Enamelled", "Ultra high current"]
    },

    // BARE COPPER
    {
      id: 217,
      category: "bare",
      mainCategory: "Bare Copper",
      type: "Bare 100mm",
      image: "/images/products/bare-100mm.jpg",
      icon: "🧵",
      sizes: ["100mm"],
      material: "Copper",
      stock: "Available",
      application: "Earthing, busbars",
      features: ["Bare copper", "High conductivity", "Grounding"]
    },
    {
      id: 218,
      category: "bare",
      mainCategory: "Bare Copper",
      type: "1.38mm copper",
      image: "/images/products/bare-1.38mm.jpg",
      icon: "🧵",
      sizes: ["1.38mm"],
      material: "Copper",
      stock: "Available",
      application: "Earthing, small conductors",
      features: ["Bare", "Flexible", "Grounding"]
    },
    // BARE ALUMINIUM
    {
      id: 219,
      category: "bare-al",
      mainCategory: "Bare Aluminium",
      type: "Bare Aluminium 50mm²",
      image: "/images/products/aluminium-single.jpg",
      icon: "⚪",
      sizes: ["50mm²"],
      material: "Aluminium",
      stock: "Available",
      application: "Earthing, overhead transmission, busbars",
      features: ["Lightweight", "Good conductivity", "Economical", "Corrosion resistant"]
    },
    {
      id: 220,
      category: "bare-al",
      mainCategory: "Bare Aluminium",
      type: "Bare Aluminium 70mm²",
      image: "/images/products/aluminium-single.jpg",
      icon: "⚪",
      sizes: ["70mm²"],
      material: "Aluminium",
      stock: "Available",
      application: "Earthing, overhead transmission, busbars",
      features: ["Lightweight", "Good conductivity", "Economical"]
    },
    {
      id: 221,
      category: "bare-al",
      mainCategory: "Bare Aluminium",
      type: "Bare Aluminium 95mm²",
      image: "/images/products/aluminium-single.jpg",
      icon: "⚪",
      sizes: ["95mm²"],
      material: "Aluminium",
      stock: "Available",
      application: "Earthing, overhead transmission, busbars",
      features: ["Lightweight", "Good conductivity", "Economical"]
    },
    {
      id: 222,
      category: "bare-al",
      mainCategory: "Bare Aluminium",
      type: "Bare Aluminium 120mm²",
      image: "/images/products/aluminium-single.jpg",
      icon: "⚪",
      sizes: ["120mm²"],
      material: "Aluminium",
      stock: "Available",
      application: "Earthing, overhead transmission, busbars",
      features: ["Lightweight", "Good conductivity", "Economical"]
    },
    {
      id: 223,
      category: "bare-al",
      mainCategory: "Bare Aluminium",
      type: "Bare Aluminium 150mm²",
      image: "/images/products/aluminium-single.jpg",
      icon: "⚪",
      sizes: ["150mm²"],
      material: "Aluminium",
      stock: "Available",
      application: "Earthing, overhead transmission, busbars",
      features: ["Lightweight", "Good conductivity", "Economical"]
    },
    {
      id: 224,
      category: "bare-al",
      mainCategory: "Bare Aluminium",
      type: "Bare Aluminium 185mm²",
      image: "/images/products/aluminium-single.jpg",
      icon: "⚪",
      sizes: ["185mm²"],
      material: "Aluminium",
      stock: "Available",
      application: "Earthing, overhead transmission, busbars",
      features: ["Lightweight", "Good conductivity", "Economical"]
    },
    {
      id: 225,
      category: "bare-al",
      mainCategory: "Bare Aluminium",
      type: "Bare Aluminium 240mm²",
      image: "/images/products/aluminium-single.jpg",
      icon: "⚪",
      sizes: ["240mm²"],
      material: "Aluminium",
      stock: "Available",
      application: "Earthing, overhead transmission, busbars",
      features: ["Lightweight", "Good conductivity", "Economical"]
    }
  ];

  // Get unique categories with counts
  const categoryCounts = catalogueData.reduce((acc, product) => {
    acc[product.category] = (acc[product.category] || 0) + 1;
    return acc;
  }, {});

  // Updated categories with image mappings
  const categories = [
    { id: 'abc', label: 'ABC Cables', icon: '☁️', image: '/images/products/abc.JPG', description: 'Aerial bundled cables for overhead distribution', count: categoryCounts['abc'] || 0 },
    { id: 'armoured-al', label: 'Armoured Aluminium', icon: '🛡️⚪', image: '/images/products/armoured-cable.jpg', description: 'Steel wire armoured aluminium cables', count: categoryCounts['armoured-al'] || 0 },
    { id: 'armoured-cu', label: 'Armoured Copper', icon: '🛡️🔴', image: '/images/products/armoured-cable.jpg', description: 'High conductivity copper armoured cables', count: categoryCounts['armoured-cu'] || 0 },
    { id: 'automotive', label: 'Automotive', icon: '🚗', image: '/images/products/auto-0.5.jpg', description: 'PVC covered conductors for vehicles', count: categoryCounts['automotive'] || 0 },
    { id: 'cnc', label: 'CNC Cables', icon: '⚡', image: '/images/products/cnc-cable.jpg', description: 'Concentric neutral for power distribution', count: categoryCounts['cnc'] || 0 },
    { id: 'domestic', label: 'Domestic', icon: '🏠', image: '/images/products/domestic-cables.jpg', description: 'House wiring cables', count: categoryCounts['domestic'] || 0 },
    { id: 'flexible', label: 'Flexible', icon: '〰️', image: '/images/products/flexible-cables.jpg', description: 'Flexible cables for industrial use', count: categoryCounts['flexible'] || 0 },
    { id: 'nonarm-al', label: 'Non-Arm Al', icon: '⚪', image: '/images/products/aluminium-single.jpg', description: 'Unarmoured aluminium cables', count: categoryCounts['nonarm-al'] || 0 },
    { id: 'nonarm-cu', label: 'Non-Arm Cu', icon: '🔴', image: '/images/products/copper-single.jpg', description: 'Unarmoured copper cables', count: categoryCounts['nonarm-cu'] || 0 },
    { id: 'solar', label: 'Solar', icon: '☀️', image: '/images/products/solar-pump.jpg', description: 'Solar photovoltaic cables', count: categoryCounts['solar'] || 0 },
    { id: 'submersible', label: 'Submersible', icon: '💧', image: '/images/products/submersible-cables.jpg', description: 'Water-resistant for borehole pumps', count: categoryCounts['submersible'] || 0 },
    { id: 'twin', label: 'Twin Cables', icon: '⚡⚡', image: '/images/products/domestic-cables.jpg', description: 'Twin flat and twin with earth', count: categoryCounts['twin'] || 0 },
    { id: 'welding', label: 'Welding', icon: '⚡', image: '/images/products/welding-cable.jpg', description: 'Flexible cables for welding', count: categoryCounts['welding'] || 0 },
    { id: 'winding', label: 'Winding Wires', icon: '🌀', image: '/images/products/copper-single.jpg', description: 'Enamelled copper for motors', count: categoryCounts['winding'] || 0 },
    { id: 'bare', label: 'Bare Copper', icon: '🧵', image: '/images/products/copper-single.jpg', description: 'Bare copper conductors', count: categoryCounts['bare'] || 0 },
    { id: 'bare-al', label: 'Bare Aluminium', icon: '⚪', image: '/images/products/aluminium-single.jpg', description: 'Bare aluminium conductors for earthing and transmission', count: categoryCounts['bare-al'] || 0 }
  ];

  const handleCategoryClick = (categoryId) => {
    if (selectedCategory === categoryId) {
      setSelectedCategory(null); // Back to categories view
    } else {
      setSelectedCategory(categoryId);
      setExpandedProduct(null); // Reset expanded product when changing category
    }
  };

  const handleBackToCategories = () => {
    setSelectedCategory(null);
    setExpandedProduct(null);
  };

  const toggleExpand = (productId) => {
    if (expandedProduct === productId) {
      setExpandedProduct(null);
    } else {
      setExpandedProduct(productId);
    }
  };

  // Filter products based on selected category and search
  const filteredProducts = selectedCategory
    ? catalogueData.filter(product => 
        product.category === selectedCategory &&
        (searchTerm === '' || 
         product.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
         (product.sizes && product.sizes.some(s => s.toLowerCase().includes(searchTerm.toLowerCase()))))
      )
    : [];

  // If a category is selected, show products in that category
  if (selectedCategory) {
    const category = categories.find(c => c.id === selectedCategory);
    
    return (
      <div className="catalogue-page category-view">
        <div className="container">
          {/* Back Button */}
          <button className="back-button" onClick={handleBackToCategories}>
            ← Back to All Categories
          </button>

          {/* Category Header with Image */}
          <div className="category-header">
            <div className="category-header-image">
              <img src={category.image} alt={category.label} />
            </div>
            <div className="category-header-info">
              <div className="category-header-icon">{category.icon}</div>
              <div>
                <h1 className="category-title">{category.label}</h1>
                <p className="category-description">{category.description}</p>
              </div>
            </div>
          </div>

          {/* Search within category */}
          <div className="catalogue-search">
            <input
              type="text"
              placeholder={`Search in ${category.label}...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <span className="search-icon">🔍</span>
          </div>

          <div className="results-count">
            Showing {filteredProducts.length} products in {category.label}
          </div>

          {/* Products Grid */}
          <div className="catalogue-enhanced-grid">
            {filteredProducts.map((product) => (
              <div key={product.id} className={`catalogue-enhanced-card ${expandedProduct === product.id ? 'expanded' : ''}`}>
                <div className="card-header" style={{ backgroundColor: product.category.includes('cu') ? '#8B0000' : '#1C1C1C' }}>
                  {product.image && (
                    <div className="card-header-image">
                      <img src={product.image} alt={product.type} />
                    </div>
                  )}
                  <span className="card-icon">{product.icon}</span>
                  <h3>{product.type}</h3>
                  <button className="expand-btn" onClick={() => toggleExpand(product.id)}>
                    {expandedProduct === product.id ? '−' : '+'}
                  </button>
                </div>
                
                <div className="card-content">
                  <div className="card-main-category">{product.mainCategory}</div>
                  
                  <div className="card-specs">
                    {product.sizes && (
                      <div className="spec-item">
                        <span className="spec-label">Sizes:</span>
                        <div className="size-chips">
                          {Array.isArray(product.sizes) ? 
                            product.sizes.slice(0, 3).map((size, i) => (
                              <span key={i} className="size-chip">{size}</span>
                            )) : 
                            <span className="size-chip">{product.sizes}</span>
                          }
                          {product.sizes && product.sizes.length > 3 && (
                            <span className="size-chip more">+{product.sizes.length - 3}</span>
                          )}
                        </div>
                      </div>
                    )}
                    
                    {product.cores && (
                      <div className="spec-item">
                        <span className="spec-label">Cores:</span>
                        <span className="spec-value">{product.cores}</span>
                      </div>
                    )}
                    
                    {product.colors && (
                      <div className="spec-item">
                        <span className="spec-label">Colors:</span>
                        <span className="spec-value">
                          {Array.isArray(product.colors) ? product.colors.slice(0, 3).join(', ') : product.colors}
                          {product.colors && product.colors.length > 3 && ' ...'}
                        </span>
                      </div>
                    )}
                    
                    {product.voltage && (
                      <div className="spec-item">
                        <span className="spec-label">Voltage:</span>
                        <span className="spec-value">{product.voltage}</span>
                      </div>
                    )}
                    
                    {product.standard && (
                      <div className="spec-item">
                        <span className="spec-label">Standard:</span>
                        <span className="spec-value">{product.standard}</span>
                      </div>
                    )}
                    
                    {product.stock && (
                      <div className="spec-item stock">
                        <span className="spec-label">Stock:</span>
                        <span className="spec-value">{product.stock}</span>
                      </div>
                    )}
                  </div>

                  {expandedProduct === product.id && (
                    <div className="product-extended">
                      <h4>Features & Applications</h4>
                      {product.features && (
                        <ul className="feature-list">
                          {product.features.map((feature, i) => (
                            <li key={i}>✓ {feature}</li>
                          ))}
                        </ul>
                      )}
                      {product.application && (
                        <p className="application-text">
                          <strong>Application:</strong> {product.application}
                        </p>
                      )}
                    </div>
                  )}
                  
                  <div className="card-actions">
                    <button className="btn-quote">Request Quote</button>
                    <button className="btn-view" onClick={() => toggleExpand(product.id)}>
                      {expandedProduct === product.id ? 'Less Details' : 'More Details'}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="no-results">
              <p>No products found matching "{searchTerm}"</p>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Otherwise show all categories (dashboard view) with images
  return (
    <div className="catalogue-page">
      <div className="container">
        <h1 className="catalogue-title">Product Catalogue</h1>
        <p className="catalogue-subtitle">Browse by category - Click any category to view products</p>

        <div className="catalogue-search">
          <input
            type="text"
            placeholder="Search categories..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <span className="search-icon">🔍</span>
        </div>

        <div className="categories-dashboard">
          {categories
            .filter(cat => 
              cat.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
              cat.description.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .map((category) => (
              <div
                key={category.id}
                className="category-dashboard-card"
                onClick={() => handleCategoryClick(category.id)}
              >
                <div className="category-dashboard-image">
                  <img src={category.image} alt={category.label} />
                  <div className="category-image-overlay">
                    <span className="category-icon-large">{category.icon}</span>
                  </div>
                </div>
                <h3>{category.label}</h3>
                <p className="category-description-small">{category.description}</p>
                <div className="category-footer">
                  <span className="product-count">{category.count} products</span>
                  <span className="view-link">View →</span>
                </div>
              </div>
            ))}
        </div>

        {categories.filter(cat => 
          cat.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
          cat.description.toLowerCase().includes(searchTerm.toLowerCase())
        ).length === 0 && (
          <div className="no-results">
            <p>No categories found matching "{searchTerm}"</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Catalogue;